import { OrderingInitialState, SetPreparationTimeAction } from '@reducers/ordering/types';

export const setPreparationTime = (
  state: OrderingInitialState,
  action: SetPreparationTimeAction
): OrderingInitialState => ({
  ...state,
  orderState: {
    ...state.orderState,
    preparationTime: action.payload.preparationTime,
  },
});
